<template lang="html">
  <div class="fill-height">
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn icon width="40" height="40" class="mr-2" @click="goBack()">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <v-spacer />
              <div class="d-flex align-center">
                <div v-if="$store.state.selected_type === 'DINE-IN'" class="wrap-table">
                  <div class="wrap-table-icon">
                    <img :src="icon_table" :alt="$t('table')">
                  </div>
                  <div class="wrap-table-content">
                    <div class="wrap-table-text">
                      {{ $t('table') }} {{ noTable }}
                    </div>
                  </div>
                </div>
                <div>
                  <locale />
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <div class="banner-splash" :style="{ backgroundImage: 'url(' + image + ')', height: 'calc(44% - 72px)' }" />
    <div class="container-banner-splash">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
            <div class="logo-banner-splash left ml-0">
              <template v-if="$store.state.selected_outlet">
                <img :src="$store.state.selected_outlet.logo" :alt="$store.state.selected_outlet.name" class="img-banner-splash">
              </template>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
            <div class="mt-4">
              <div class="subtitle-splash">
                {{ $t('v2.enter_your_phone_number') }}
              </div>
            </div>
            <div class="mt-2">
              <l-a-phone-number v-model="form.phone" class="inputv2-space" />
            </div>
            <div class="section-bottom">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
                    <div class="mb-6 subtext">
                      {{ $t('v2.agreed') }}
                      <router-link :to="{ name: '_privacy_policy' }" class="text-direction-none font-weight-bold ol-brand">
                        {{ $t('v2.privacy_policy') }}
                      </router-link>
                    </div>
                    <v-btn block color="primary" height="40" class="text-none br-5" @click="checkPhone()">
                      {{ $t('v2.next') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </ValidationObserver>
        </v-col>
      </v-row>
    </v-container>
    <v-bottom-sheet v-model="dialog.limit_resend" content-class="dialog-icon">
      <v-sheet class="sheet-border">
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="mt-12 text-center mb-10">
                <img src="@/assets/images/v2/img/limit_resend.png" alt="Limit">
              </div>
              <div class="text-center">
                <div class="font-18 font-weight-700 ol-black mb-4">
                  {{ $t('v2.verification_reached_limit') }}
                </div>
                <div class="font-14 font-weight-400 ol-black mb-10" v-html="$t('v2.you_have_verified_several_times', { time: formatTimeLimit })" />
                <v-btn block color="white" class="br-5 text-none ol-elevation-1 font-weight-700 letter-spacing-normal" @click="dialog.limit_resend = false">
                  {{ $t('v2.cancel2') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
import {
  ValidationObserver
} from 'vee-validate'
import Locale from '@/components/v2/Locale'
import LAPhoneNumber from '@/components/modules/LAphone/Index'
import {
  checkPhone as checkPhoneUser,
  requestOTP
} from '@/api/auth'
export default {
  components: {
    ValidationObserver,
    Locale,
    LAPhoneNumber
  },
  data() {
    return {
      dialog: {
        limit_resend: false
      },
      limit_time: 0,
      limitInterval: null,
      image: require('@/assets/images/v2/img/background_banner.png'),
      icon_table: require('@/assets/images/v2/img/icon_table.png'),
      detail_table: {},
      cart: {},
      form: {
        phone: ''
      },
      form_otp: {
        phone: '',
        otp_type: 3
      }
    }
  },
  computed: {
    formatTimeLimit() {
      let days = Math.floor(this.limit_time / (1000 * 60 * 60 * 24))
      let hours = Math.floor((this.limit_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((this.limit_time % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.limit_time % (1000 * 60)) / 1000)
      let result
      if (this.limit_time < 0) {
        result = 'EXPIRED'
      } else {
        days = days === 0 ? '' : days + ' : '
        hours = hours < 10 ? hours === 0 ? '' : '0' + hours + ':' : hours + ':'
        minutes = minutes < 10 ? '0' + minutes + ':' : minutes + ':'
        seconds = seconds < 10 ? '0' + seconds : seconds
        result = days + hours + minutes + seconds
      }
      return result
    },
    noTable() {
      if (!this.$isEmpty(this.detail_table) && !this.$isEmpty(this.detail_table.table_detail) && this.detail_table.table_detail.name) {
        return this.detail_table.table_detail.name
      } else {
        return ''
      }
    }
  },
  watch: {
    formatTimeLimit: function(newItem) {
      if (newItem === 'EXPIRED' || newItem === '00:00') {
        this.dialog.limit_resend = false
      }
    }
  },
  mounted() {
    const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
    if (LOCAL_DATA_CART) {
      this.cart = JSON.parse(LOCAL_DATA_CART)
    }
    const DETAIL_TABLE = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_table')
    if (DETAIL_TABLE) {
      this.detail_table = JSON.parse(DETAIL_TABLE)
    }
  },
  methods: {
    goBack() {
      const query = this.$route.query.redirect
      if (query) {
        if (query === 'order') {
          this.$router.push({ name: query, params: { id: this.$route.query.id }}).catch(() => {})
        } else {
          this.$router.push({ name: query }).catch(() => {})
        }
      } else {
        this.$router.go(-1)
      }
    },
    async checkPhone() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        try {
          const { data } = await checkPhoneUser(this.form)
          this.$store.dispatch('save_token', data)
          const query = this.$route.query.redirect
          if (query) {
            if (query === 'order') {
              this.$router.push({ name: query, params: { id: this.$route.query.id }}).catch(() => {})
            } else if (query === '_checkout') {
              this.$router.push({ name: query, query: { user_type: 'old' }}).catch(() => {})
            } else {
              this.$router.push({ name: query }).catch(() => {})
            }
          } else {
            this.$router.push({ name: '_splash' }).catch(() => {})
          }
        } catch (e) {
          if (e.statusCode === 403) {
            try {
              this.form_otp.phone = this.form.phone
              const { data } = await requestOTP(this.form_otp)
              const time = data.data.detail.expiry_date
              this.$router.push({ name: '_verification', query: { redirect: this.$route.query.redirect, otp_type: this.form_otp.otp_type, phone: this.form_otp.phone, expiry_date: time }}).catch(() => {})
              this.$store.state.show_error = true
              this.$store.state.error_message = this.$t('v2.code_sent_successfully')
              this.$store.state.error_type = 200
            } catch (e) {
              if (e.statusCode === 406) {
                try {
                  this.form_otp.phone = this.form.phone
                  this.form_otp.otp_type = 1
                  const { data } = await requestOTP(this.form_otp)
                  const time = data.data.detail.expiry_date
                  this.$router.push({ name: '_verification', query: { redirect: this.$route.query.redirect, otp_type: this.form_otp.otp_type, phone: this.form_otp.phone, expiry_date: time }}).catch(() => {})
                  this.$store.state.show_error = true
                  this.$store.state.error_message = this.$t('v2.code_sent_successfully')
                  this.$store.state.error_type = 200
                } catch (e) {
                  if (e.statusCode === 429) {
                    this.dialog.limit_resend = true
                    this.getLimitTime(e.data.unlocked_in)
                  } else {
                    this.$store.state.show_error = true
                    this.$store.state.error_message = e.string
                    this.$store.state.error_type = e.statusCode
                  }
                }
              } else if (e.statusCode === 429) {
                this.dialog.limit_resend = true
                this.getLimitTime(e.data.unlocked_in)
              } else {
                this.$store.state.show_error = true
                this.$store.state.error_message = e.string
                this.$store.state.error_type = e.statusCode
              }
            }
          } else {
            if (e.statusCode === 429) {
              this.dialog.limit_resend = true
              this.getLimitTime(e.data.unlocked_in)
            } else {
              this.$store.state.show_error = true
              this.$store.state.error_message = e.string
              this.$store.state.error_type = e.statusCode
            }
          }
        }
      } else {
        this.$store.state.show_error = true
        this.$store.state.error_message = this.$t('v2.phone_number_is_not_filled')
        this.$store.state.error_type = 400
      }
    },
    getLimitTime(time) {
      const countDownDate = new Date(time).getTime()
      const _this = this
      this.limitInterval = setInterval(function() {
        var now = new Date().getTime()
        _this.limit_time = countDownDate - now
        if (_this.limit_time < 0) {
          clearInterval(_this.limitInterval)
        }
      }, 1000)
    }
  }
}
</script>
